module.exports = __webpack_public_path__ + "static/media/icon2.3bdb2b87.svg";